import React from 'react'

const OpKeywordIgnore = ({ settings, onChange }) => {
  const handleChange = (event) => {
    onChange('ignore_keywords', event.target.value.split(/\r?\n/))
  }

  return (
    <div className="keyword-ignore-container">
      <span className="container-label">
        Ignore Keywords/Targets
      </span>
      <ul>
        <li>
          Enter one keyword per line to tell Entourage which targets
          you do <u>NOT</u> want to apply keyword optimization automation rules to.
          An example may be your brand name or a main keyword
          you’re willing to take a slight loss on.
        </li>
        <li>
          Remember to enter singular, plural, and stemmed versions of
          keywords you want to ensure the system ignores.
        </li>
      </ul>
      <textarea
        value={settings.ignore_keywords.join('\n')}
        onChange={handleChange}
      />
    </div>
  )
}

export default OpKeywordIgnore
